interface LandingStateProps {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function LandingLoadingState({ message = "Loading…" }: { message?: string }) {
  return (
    <p className="py-16 text-center text-[16px] text-landing-muted" role="status">
      {message}
    </p>
  );
}

export function LandingErrorState({
  message,
  actionLabel = "Try again",
  onAction,
}: LandingStateProps) {
  return (
    <div className="py-16 text-center">
      <p className="text-[16px] text-landing-muted">{message}</p>
      {onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="mt-4 text-[14px] font-semibold text-landing-button hover:underline"
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
